import { Menu } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "BBJMenu";

export const classes = {
  popoverPaper: `${PREFIX}-popoverPaper`,
};

export const CustomMenu = styled(Menu, {
  shouldForwardProp: (prop) => prop !== "btnRef",
})(({ btnRef }) => ({
  "& ul": {
    height: "100%",
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },
  [`& .${classes.popoverPaper}`]: {
    overflowY: "auto",
    outline: "none",
    border: "1px solid #E3E5EE",
    filter: "none",
    minWidth: btnRef?.current?.clientWidth || undefined,
    padding: 0,
    marginTop: 0,
  },
}));
